// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__Ux9Wh"};